/**
 * Service de gestion des offres de voyage
 * Centralise tous les appels API liés aux offres de voyage
 */
import apiService from './api.service';

class OfferService {
  /**
   * Récupérer la liste des offres de voyage
   */
  async getAllOffers() {
    return await apiService.get('offreVoyage/all');
  }

  /**
   * Récupérer la liste des offres par compagnie
   * Note: L'API utilise POST au lieu de GET
   * @param {string} companyName - Nom de la compagnie
   * @param {boolean} forceRefresh - Si true, bypass le cache
   */
  async getOffersByCompany(companyName, forceRefresh = false) {
    const response = await apiService.postForGet(
      'offreVoyages/getTravelOfferByCompagnieTransport',
      {
        data: {
          compagnieTransportRaisonSociale: companyName
        }
      },
      {
        cache: !forceRefresh // Si forceRefresh = true, cache = false
      }
    );
    return response.items || [];
  }

  /**
   * Créer une offre de voyage
   */
  async createOffer(offerData) {
    return await apiService.post('offreVoyage', offerData);
  }

  /**
   * Mettre à jour une offre de voyage
   */
  async updateOffer(offerId, offerData) {
    return await apiService.put(`offreVoyage/${offerId}`, offerData);
  }

  /**
   * Supprimer une offre de voyage
   */
  async deleteOffer(offerId) {
    return await apiService.delete(`offreVoyage/${offerId}`);
  }

  /**
   * Obtenir les détails d'une offre
   */
  async getOfferDetails(offerId) {
    return await apiService.get(`offreVoyage/${offerId}`);
  }

  /**
   * Planifier une offre de voyage
   */
  async planOffer(planData) {
    return await apiService.post('programme', planData);
  }

  /**
   * Récupérer les programmes d'une offre
   */
  async getOfferPrograms(offerId) {
    return await apiService.get(`programme/offre/${offerId}`);
  }
}

export default new OfferService();
